import React from "react";
import { Loader2 } from "lucide-react";

export function Loading({ label = "Loading", className = "" }) {
  return (
    <div className={"flex flex-col items-center justify-center gap-2 py-10 text-[color:var(--ink-3)] " + className}>
      <Loader2 className="w-5 h-5 animate-spin text-[color:var(--brand-ocean)]" />
      <span className="text-sm">{label}…</span>
    </div>
  );
}
